import React from 'react';
import Segment from '../Segment';

export type LegProps = {
  leg: {
    segments: any;
  };
  id: number;
  isSem?: boolean;
  isAlternativeItinerary?: boolean;
};

const Leg: React.FC<LegProps> = ({
  leg,
  id,
  isSem,
  isAlternativeItinerary,
}) => {
  const [segment] = leg.segments;
  return (
    <Segment
      segment={segment}
      id={id}
      isSem={isSem}
      isAlternativeItinerary={isAlternativeItinerary}
    />
  );
};

export default Leg;
